module.exports = __webpack_public_path__ + "static/media/delete-button.003cb710.svg";